export function downFile(response,fileName,that){
  const blob = new Blob([response.data], {
    // type是需要对应的文件类型
    type:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8",
  });

  if ("download" in document.createElement("a")) {
    // // 非IE下载
    const elink = document.createElement("a");
    elink.download = fileName;
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    // console.log(blob, elink.href, "href", elink);

    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink);
  } else {
    // IE10+下载
    navigator.msSaveBlob(blob, fileName);
  }

  that.isActive = false
}





// WEBPACK FOOTER //
// ./src/util/DownFile.js